import { GET_ORDER_GIFT_WRAP_INFO } from '../actionTypes/OrderActionTypes';

export default function OrderGiftWrapInfoReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_ORDER_GIFT_WRAP_INFO:
            return action.payload;
        default:
            return state;
    }
}
